import { AccordionDetails, Box, Divider, Typography } from "@mui/material";
import { FormattedMessage as T } from "react-intl";
import { SkuContentRule, Skus } from "services/KnowfullyAdminClient";
import { RuleType } from "types/common-types";
import { SkuFormProps } from "types/sku-related-types";
import SkuRuleDetailOrganizationsList from "./SkuRuleDetailOrganizationsList";
import SkuRuleDetailProductList from "./SkuRuleDetailProductList";
import SkuRuleDetailProfessionForm from "./SkuRuleDetailProfessionForm";
import SkuRuleDetailSkuContentsList from "./SkuRuleDetailSkuContentsList";
import SkuRuleDetailSkusForm from "./SkuRuleDetailSkusForm";
import SkuRuleDetailTagForm from "./SkuRuleDetailTagForm";

type SkuRuleAccordionDetailsProps = {
  sku: Skus;
  skuRule: SkuContentRule;
  readonly: boolean;
  index: number;
} & SkuFormProps;

const SkuRuleAccordionDetails = ({
  sku,
  skuRule,
  ...rest
}: SkuRuleAccordionDetailsProps) => {
  return (
    <AccordionDetails>
      <Box width={1} px={2} pb={2}>
        <Divider />
        <Box mb={2} />
        <Typography variant="h6" gutterBottom>
          <T id="ruleDetailsLabel" />
        </Typography>

        {skuRule.ruleType?.name === RuleType.Product && (
          <SkuRuleDetailProductList
            sku={sku}
            skuContentRule={skuRule}
            dialogTitleKey="skuRuleProductFilterCreateTitle"
            {...rest}
          />
        )}

        {skuRule.ruleType?.name === RuleType.Sku && (
          <SkuRuleDetailSkusForm sku={sku} skuContentRule={skuRule} {...rest} />
        )}

        {skuRule.ruleType?.name === RuleType.Profession && (
          <SkuRuleDetailProfessionForm
            sku={sku}
            skuContentRule={skuRule}
            {...rest}
          />
        )}

        {skuRule.ruleType?.name === RuleType.Tag && (
          <SkuRuleDetailTagForm
            sku={sku}
            skuContentRule={skuRule}
            {...rest}
          />
        )}

        {skuRule.ruleType?.name === RuleType.Series && (
          <SkuRuleDetailProductList
            sku={sku}
            skuContentRule={skuRule}
            dialogTitleKey="skuRuleSeriesFilterCreateTitle"
            {...rest}
          />
        )}

        {skuRule.ruleType?.name === RuleType.Organization && (
          <SkuRuleDetailOrganizationsList
            sku={sku}
            skuContentRule={skuRule}
            dialogTitleKey="skuRuleOrganizationFilterCreateTitle"
            {...rest}
          />
        )}

        {skuRule.ruleType?.name === RuleType.SkuContent && (
          <SkuRuleDetailSkuContentsList
            sku={sku}
            skuContentRule={skuRule}
            dialogTitleKey="skuRuleSkuContentFilterCreateTitle"
            {...rest}
          />
        )}
      </Box>
    </AccordionDetails>
  );
};

export default SkuRuleAccordionDetails;
